import { Button, TextField } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import { makeStyles } from '@material-ui/core/styles';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import React from 'react';
import { Box } from '../../UI';
import './custom.css';

export default function Signup({ setValue }) {
	const classes = useStyles();
	const [values, setValues] = React.useState({
		fname: 'Saul',
		lname: 'Hudson',
		email: 'saul.hudson@axcess.com',
		phone: '+447123456789',
		password: '12345678',
		repeatPassword: '12345678',
		showPassword: false,
	});

	const handleChange = prop => event => {
		setValues({ ...values, [prop]: event.target.value });
	};
	const handleClickShowPassword = () => {
		setValues({ ...values, showPassword: !values.showPassword });
	};
	const handleMouseDownPassword = event => {
		event.preventDefault();
	};

	return (
		<Box>
			<form className={classes.form}>
				<Box display="flex" justifyContent="space-between">
					<TextField
						label="First Name"
						variant="outlined"
						className={`${classes.input} ${classes.half}`}
						value={values.fname}
						onChange={handleChange('fname')}
					/>
					<TextField
						label="Last Name"
						variant="outlined"
						className={`${classes.input} ${classes.half}`}
						value={values.lname}
						onChange={handleChange('lname')}
					/>
				</Box>
				<TextField
					label="Email"
					variant="outlined"
					className={classes.input}
					value={values.email}
					onChange={handleChange('email')}
				/>
				<TextField
					label="Phone"
					variant="outlined"
					className={classes.input}
					value={values.phone}
					onChange={handleChange('phone')}
				/>
				<Box display="flex" justifyContent="space-between">
					<FormControl className={`${classes.input} ${classes.half}`} variant="outlined">
						<InputLabel htmlFor="password">Password</InputLabel>
						<OutlinedInput
							id="password"
							type={values.showPassword ? 'text' : 'password'}
							value={values.password}
							onChange={handleChange('password')}
							endAdornment={
								<InputAdornment position="end">
									<IconButton
										aria-label="toggle password visibility"
										onClick={handleClickShowPassword}
										onMouseDown={handleMouseDownPassword}
										edge="end"
									>
										{values.showPassword ? <Visibility /> : <VisibilityOff />}
									</IconButton>
								</InputAdornment>
							}
							labelWidth={70}
						/>
					</FormControl>
					<FormControl className={`${classes.input} ${classes.half}`} variant="outlined">
						<InputLabel htmlFor="password">Repeat Password</InputLabel>
						<OutlinedInput
							id="password"
							type={values.showPassword ? 'text' : 'password'}
							value={values.repeatPassword}
							onChange={handleChange('repeatPassword')}
							endAdornment={
								<InputAdornment position="end">
									<IconButton
										aria-label="toggle password visibility"
										onClick={handleClickShowPassword}
										onMouseDown={handleMouseDownPassword}
										edge="end"
									>
										{values.showPassword ? <Visibility /> : <VisibilityOff />}
									</IconButton>
								</InputAdornment>
							}
							labelWidth={70}
						/>
					</FormControl>
				</Box>
				<Button variant="contained" color="primary" onClick={() => setValue(0)}>
					Signup
				</Button>
			</form>
		</Box>
	);
}

const useStyles = makeStyles(theme => ({
	form: {
		zIndex: 2,
		display: 'flex',
		flexDirection: 'column',
		paddingTop: theme.spacing(4),
	},
	input: {
		background: '#4D4D4D',
		'& input, & label, & svg': {
			color: '#9D9D9D !important',
		},
		marginBottom: theme.spacing(3),
	},
	half: {
		width: '49%',
	},
	button: {
		marginTop: theme.spacing(2),
	},
}));
